import { AccountType, BillItem, BillState } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { Typography } from '@optimus-web/core';
import { Target } from '@mews/enums';
import { Dash } from '@mews-commander/ui';
import {
    BillDetailEnterpriseLink,
    CompanyBillingEnterpriseLink,
    CustomerBillingEnterpriseLink,
} from '../../../payment';
import { PaymentDetailsSidePanelRow } from './PaymentDetailsSidePanelRow';

export const PaymentDetailSidePanelBill = ({ bill }: { bill?: BillItem | null }) => {
    if (bill?.state === BillState.Open) {
        const AccountBillingLink =
            bill.accountType === AccountType.Company ? CompanyBillingEnterpriseLink : CustomerBillingEnterpriseLink;
        return (
            <>
                <PaymentDetailsSidePanelRow labelTextKey={TextKey.Bill}>
                    {bill.accountId ? (
                        <Typography textStyle="bodyMedium" as="div">
                            <AccountBillingLink
                                accountId={bill.accountId}
                                billId={bill.id}
                                target={Target.Blank}
                                data-test-id="payout-payment-detail-bill"
                            >
                                {bill.name || <Dash />}
                            </AccountBillingLink>
                        </Typography>
                    ) : (
                        bill.name || <Dash />
                    )}
                </PaymentDetailsSidePanelRow>
            </>
        );
    }

    return (
        <>
            <PaymentDetailsSidePanelRow labelTextKey={TextKey.Bill}>
                {bill?.id ? (
                    <Typography textStyle="bodyMedium" as="div">
                        <BillDetailEnterpriseLink
                            accountId={bill.accountId}
                            billId={bill.id}
                            target={Target.Blank}
                            data-test-id="payout-payment-detail-bill"
                        >
                            {bill?.name || <Dash />}
                        </BillDetailEnterpriseLink>
                    </Typography>
                ) : (
                    bill?.name || <Dash />
                )}
            </PaymentDetailsSidePanelRow>
        </>
    );
};
